export default __webpack_public_path__ + "static/client2-3dedaf8fd4f182621b0c5c222d782a77.svg";